import React from 'react';
import styles from './SheetHeader.module.scss';
import { Container, Row, Col } from 'react-bootstrap';

const SheetHeader = () => {
  return (
    <Container className={styles.SheetHeader} data-testid="SheetHeader">
      <div className={styles.TopHeader}>
        <Row>
          <Col>
            <h1 className={styles.Title}>Timesheet</h1>
          </Col>
        </Row>
      </div>
      <Row>
        <Col>
          <p>
            Please submit your timesheet below by Friday at midnight to prevent
            any delays.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default SheetHeader;
